<template>
  <v-select class="service-code"
            v-model="selectedValue"
            :options="serviceCodes"
            label="display_name"
            style="width: 300px;"
            :disabled="!(serviceTypeId)"
            @change="onChange">
  </v-select>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue'
import { useStore } from 'vuex'
import _ from 'underscore'

const props = defineProps({
  modelValue: {
    type: [String, Number, null],
    default: null
  },
  serviceTypeId: {
    type: Number,
    default: null
  }
})

const emit = defineEmits(['update:modelValue', 'change'])

const store = useStore()
const serviceCodes = ref([])

const getServiceUniqueCodes = computed(() => store.getters['session/getServiceUniqueCodes'])

const selectedValue = computed({
  get: () => {
    return _.find(serviceCodes.value, sc => sc.id === Number(props.modelValue)) || null
  },
  set: (value) => {
    emit('update:modelValue', value?.id ?? null)
  }
})

const onChange = (event) => {
  emit('change', event)
}

const initServiceCode = () => {
  if (props.serviceTypeId) {
    serviceCodes.value = getServiceUniqueCodes.value(props.serviceTypeId)
  } else {
    serviceCodes.value = []
  }
}

watch(() => props.serviceTypeId, () => {
  initServiceCode()
})

onMounted(() => {
  initServiceCode()
})
</script>

<style scoped>

</style>
